import { IEvent } from "@quest/adapter-interface";
import { Bitmap, Container, ISpineData, SpineBase ,ingenuity} from "@quest/base-core";
import { BaseViewGame } from "../../BaseViewGame";


export class FlowerCollectPanelView extends BaseViewGame {
    public resize(evt: IEvent): void {
        //
    }
    /**
     * to clone animations
     * @param currentFlower will define the position for flower according to reels
     * @param index 
     * @returns 
     */
    public cloneSpine(key: string, currentFlower?: number, index?: number): SpineBase {
        let flowerSpineObj: ISpineData = ingenuity.assetsData.getJSONById("main_data").flowerCollectPanel[key];
        flowerSpineObj.type = "spine";
        let flowerSpineAnim: SpineBase = this.createSpine(flowerSpineObj);
        flowerSpineAnim.visible = true;
        currentFlower && (flowerSpineAnim.x = this.json.flowerEffectAllignX[index][currentFlower - 1]);
        return flowerSpineAnim;
    }
    /**
     * to reset dynamically created animations
     */
    public resetRunTimeAnimations(): void {
        this.json.getRunTimeAnimation.forEach((name: string) => {
            let container = this.getContainerByID(name)
            container && (container.removeAll());
            container && (container.children = []);
        })
    }
    /**
     * to reset all the flowers in the panel by hiding them
     */
    public resetFlowers(): void {
        this.json.getStaticFlowers.forEach((name:string)=>{
            let container = this.getContainerByID(name);
            container.children.forEach((image: Bitmap) => {
                image.visible = false
            })
        })
    }
    /**
     * to hide purple frame
     */
    public resetPurpleFrame(): void {
        this.json.getPurpleFrameCont.forEach((name:string)=>{
            let container = this.getContainerByID(name);
            container.visible = false;
        })
    }

    public resetMiniSkullAnims(): void {
        this.json.miniSkullAnimContainers.forEach((name: string) => {
            let container = this.getContainerByID(name)
            container && (container.removeAll());
            container && (container.children = []);
        })
    }
    //to remove animated skull on bet change
    public removeCurrentAnimations(container:Container): void {
            container && (container.removeAll());
            container && (container.children = []);
    }
}
